"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchBox = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SearchBoxMixin = require("../../mixins/components/SearchBoxMixin");
var _AdornedInput = require("../AdornedInput/AdornedInput");
var _Adornment = require("../Adornment/Adornment");
var _index = require("../Icon/index");
/**
 * @extends AdornedInput
 * @since 6.4.0
 */
var SearchBox = /*#__PURE__*/(0, _styledComponents.default)(_AdornedInput.AdornedInput).withConfig({
  displayName: "SearchBox",
  componentId: "c11n-8-107-0__sc-6uapbf-0"
})(["", ""], _SearchBoxMixin.SearchBoxMixin);
exports.SearchBox = SearchBox;
SearchBox.displayName = 'SearchBox';
SearchBox.propTypes = {
  /**
   * The `Adornment` for the `SearchBox`. Defaults to a search `Icon`.
   */
  rightAdornment: _propTypes.default.node
};
SearchBox.defaultProps = {
  rightAdornment: /*#__PURE__*/_react.default.createElement(_Adornment.Adornment, null, /*#__PURE__*/_react.default.createElement(_index.IconSearch, null))
};

/** @component */